document.addEventListener('DOMContentLoaded', () => {
    const wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
    
    document.querySelectorAll('.wishlist-button').forEach(button => {
        button.addEventListener('click', (e) => {
            const productHandle = e.target.dataset.productHandle;
            if (!wishlist.includes(productHandle)) {
                wishlist.push(productHandle);
                localStorage.setItem('wishlist', JSON.stringify(wishlist));
                alert('Added to wishlist!');
            } else {
                alert('Already in wishlist!');
            }
        });
    });
});
